import { BottomNavigation, TemplateWebPages } from "../../components";
import { VStack } from "native-base";
import { platformWeb } from "../../utils";
import { DrawerScreenProps } from "@react-navigation/drawer";
import { ParamListBase } from "@react-navigation/native";
import { Content } from "./Components/Content";


export const InventoryScreen = ({ navigation }: DrawerScreenProps<ParamListBase>) => {
  return (
    <>
      <VStack flex={1}>
        {platformWeb ? (
          <TemplateWebPages navigation={navigation}>
            <Content navigation={navigation} />
          </TemplateWebPages>
        ) : (
          <>
            <Content navigation={navigation} />
            <BottomNavigation navigation={navigation}/>
          </>
        )}
      </VStack>
    </>
  );
};
